import React from 'react';
import Header from './components/Header';
import './App.css';
import GetMedia from './components/GetMedia';
import Footer from './components/Footer';


function App() {
  return (
    <div className="App">
      <Header />
      <GetMedia />
      <Footer />
    </div>
  );
}

export default App;
